<template>
  <div>
    <div class="form-row">
      <div class="form-field">
        <label for="kpp-type-select">Выберите редакцию договора:</label>
        <select id="kpp-type-select" v-model="newDoc.AGREEMENT_TYPE">
          <option
            v-for="(contract, key) in contracts"
            :value="contract.ID"
            :key="key"
          >
            {{ contract.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field">
        <button @click="sendUserData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addDocument",
  props: ["plot"],
  data() {
    return {
      url: config.backend_url,
      info: null,
      newDoc: {
        DATA: {
        }
      },
      idPlot: this.plot,
      features: [],
      services: [],
      documents: [],
      contracts: []
    };
  },
  computed: {},
  methods: {
    sendUserData: function() {
      let self = this;
      this.newDoc.PLOT = this.idPlot;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "documents/add-plot-document/",
          data: this.newDoc,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data) {
            self.info = "Договор добавлен";
            self.$emit("document-add");
          }
        });
    },
    getServicesList: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-documents/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.documents = data;
          }
        });
    },
    getContracts: function() {
      let data = {
        url: this.url + "agreementtypelist/get/",
        data: {},
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(response => {
        let data = response.data;
        if (!data.error) {
          this.contracts = data;
        }
      });
    }
  },
  created() {
    this.getPlotData();
    this.getContracts();
  }
};
</script>
